import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'
import InputImage from "./inputImage.component.jsx";

const messages = defineMessages({
    "templates.sections.form.edit.content.image.size_15_label": {
        id: 'templates.sections.form.edit.content.image.size_15_label',
        defaultMessage: '15%',
    },
    "templates.sections.form.edit.content.image.size_25_label": {
        id: 'templates.sections.form.edit.content.image.size_25_label',
        defaultMessage: "25%",
    },
    "templates.sections.form.edit.content.image.size_50_label": {
        id: 'templates.sections.form.edit.content.image.size_50_label',
        defaultMessage: "50%",
    },
    "templates.sections.form.edit.content.image.size_75_label": {
        id: 'templates.sections.form.edit.content.image.size_75_label',
        defaultMessage: "75%",
    },
    "templates.sections.form.edit.content.image.size_100_label": {
        id: 'templates.sections.form.edit.content.image.size_100_label',
        defaultMessage: "100%",
    },
    "templates.sections.form.edit.content.image.alignment_left_label": {
        id:"templates.sections.form.edit.content.image.alignment_left_label",
        defaultMessage:"Left"
    },
    "templates.sections.form.edit.content.image.alignment_center_label": {
        id:"templates.sections.form.edit.content.image.alignment_center_label",
        defaultMessage:"Center"
    },
    "templates.sections.form.edit.content.image.alignment_right_label": {
        id:"templates.sections.form.edit.content.image.alignment_right_label",
        defaultMessage:"Right"
    },
    "templates.sections.form.edit.content.imagerow.vertical_align_top": {
        id:"templates.sections.form.edit.content.imagerow.vertical_align_top",
        defaultMessage:"Top"
    },
    "templates.sections.form.edit.content.imagerow.vertical_align_middle": {
        id:"templates.sections.form.edit.content.imagerow.vertical_align_middle",
        defaultMessage:"Middle"
    },
    "templates.sections.form.edit.content.imagerow.vertical_align_bottom": {
        id:"templates.sections.form.edit.content.imagerow.vertical_align_bottom",
        defaultMessage:"Bottom"
    }
})


class ImageRowContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function(){},
            nbColumns: this.props.value.nbColumns || 4,
            verticalAlignment: this.props.value.verticalAlignment || "middle",
            imageCells: this.props.value.imageCells || []
            //images: content.image ? [content.image] : [],
            //image: content.image || null,
            //imageId: content.imageId || '',
            //alignment: content.alignment || 'center',
            //size: content.size || '25',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.onIndividualImageContentChange = this.onIndividualImageContentChange.bind(this)
        this.handleDropDownIntChange = this.handleDropDownIntChange.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            imageCells: this.state.imageCells,
            nbColumns: this.state.nbColumns,
            verticalAlignment: this.state.verticalAlignment
        })
    }

    onIndividualImageContentChange(index, imageCell) {
        this.state.imageCells[index] = imageCell
        //this.triggerChanged()
    }

    componentDidMount() {
        this.triggerChanged()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            nbColumns: nextProps.value.nbColumns || 4,
            imageCells: nextProps.value.imageCells || [],
            verticalAlignment: nextProps.value.verticalAlignment || "middle",
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handleDropDownIntChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: parseInt(value)
        }, this.triggerChanged)
    }

    render() {

        let everyImageDetails = [];
        for (let i = 0; i < this.state.nbColumns; i++) {
            everyImageDetails.push(<InputImage imageContent={this.state.imageCells[i]} imageCellIndex={i} onChange={this.onIndividualImageContentChange} key={i + "inputImageForm"}/>);
        }

        return (
            <div>
                <div className="form-group row">
                        <label className="col-2 col-form-label text-align-right" htmlFor="nbColumns">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.imagerow.nbColumn_label"
                                defaultMessage="Number of images"
                            />
                        </label>
                        <div className="col-10">
                            <select
                                name="nbColumns"
                                value={this.state.nbColumns}
                                onChange={this.handleDropDownIntChange}
                                id="nbColumn"
                                className="form-control"
                            >
                                <option value="1">
                                    1
                                </option>
                                <option value="2">
                                    2
                                </option>
                                <option value="3">
                                    3
                                </option>
                                <option value="4">
                                    4
                                </option>
                            </select>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.imagerow.nbColumn_description"
                                    defaultMessage="Number of images on the same row"
                                />
                            </small>
                        </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="verticalAlignment">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.imagerow.verticalAlignement_label"
                            defaultMessage="Vertical alignment"
                        />
                    </label>
                    <div className="col-10">
                        <select
                            name="verticalAlignment"
                            value={this.state.verticalAlignment}
                            onChange={this.handleFormChange}
                            id="verticalAlignment"
                            className="form-control"
                        >
                            <option value="top">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.imagerow.vertical_align_top"])}
                            </option>
                            <option value="middle">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.imagerow.vertical_align_middle"])}
                            </option>
                            <option value="bottom">
                                {this.props.intl.formatMessage(messages["templates.sections.form.edit.content.imagerow.vertical_align_bottom"])}
                            </option>
                        </select>
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.imagerow.vertical_align_description"
                                defaultMessage="Vertical alignment of the images"
                            />
                        </small>
                    </div>
                </div>

                {everyImageDetails}

            </div>
        );
    }
}

export default injectIntl(ImageRowContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/image-row/input.component.jsx